<template>
  <div class="document-account">
    <DocumentTitle activeClass="mb-3">즉시입금 지급 및 매출 반환 계좌</DocumentTitle>
    <table>
      <tr>
        <td>구분</td>
        <td>지급계좌</td>
      </tr>
      <tr>
        <td>은행명</td>
        <td>{{ me.withdrawalAccount.bank | bankName }}</td>
      </tr>
      <tr>
        <td>계좌번호</td>
        <td>{{ me.withdrawalAccount.accountNumber }}</td>
      </tr>
      <tr>
        <td>예금주</td>
        <td>{{ me.withdrawalAccount.holderName }}</td>
      </tr>
      <tr>
        <td>비고</td>
        <td>예금주는 대표자와 동일해야함</td>
      </tr>
    </table>
    <v-row no-gutters class="agree mt-3">
      <v-col cols="8">
        <p class="mb-0">즉시입금 지급 계좌 정보에 대한 내용에</p>
      </v-col>

      <v-col cols="4" class="text-right">
        <button @click="isAgreed = !isAgreed" :class="{ active: isAgreed }">확인함</button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DocumentTitle from '@/components/documents/DocumentTitle.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DocumentTitle,
  },
  data() {
    return {
      isAgreed: false,
      bank: '',
      bankName: '',
      accountNumber: '',
      holderName: '',
    }
  },
  computed: {
    ...mapState('auth', ['me']),
  },
  watch: {
    isAgreed(v) {
      this.$emit('emitAgreed', v)
    },
  },
  methods: {
    async getWithdrawalAccounts() {
      // 출금계좌 정보 조회
      try {
        // const { data } = await userApi.getWithdrawalAccounts()
        // this.bank = data.bank
        // this.accountNumber = data.account_number
        // this.holderName = data.holder_name
      } catch (e) {
        console.error(e, 'getWithdrawalAccounts')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.document-account {
  table {
    width: 100%;
    border-top: solid 1px #727d8c;
    border-collapse: collapse;

    tr {
      border-bottom: solid 1px #d7e1ea;
      td {
        height: 48px;
      }
      td:first-child {
        width: calc(136% / 325 * 100);
        background-color: #f4faff;
        font-weight: 600;
        font-size: 15px;
        line-height: 2.13;
        text-align: center;
        color: $black;
      }
      td:last-child {
        font-weight: 900;
        font-size: 16px;
        line-height: 2;
        text-align: center;
        color: $black;
      }
    }
  }
}
</style>
